import React from "react";
import "./TicketStatus.css";

/**
 * Ticket Status Badge Component
 * Updated for v2.0 status enum: open, in_progress, resolved, closed
 */
const TicketStatus = ({ status }) => {
    const getStatusConfig = () => {
        switch (status) {
            case "open":
                return {
                    text: "Open",
                    color: "#ffa500",
                    bgColor: "rgba(255, 165, 0, 0.1)",
                    icon: "las la-folder-open",
                };
            case "in_progress":
                return {
                    text: "In Progress",
                    color: "#007bff",
                    bgColor: "rgba(0, 123, 255, 0.1)",
                    icon: "las la-spinner",
                };
            case "resolved":
                return {
                    text: "Resolved",
                    color: "#28a745",
                    bgColor: "rgba(40, 167, 69, 0.1)",
                    icon: "las la-check-circle",
                };
            case "closed":
                return {
                    text: "Closed",
                    color: "#6c757d",
                    bgColor: "rgba(108, 117, 125, 0.1)",
                    icon: "las la-times-circle",
                };
            default:
                return {
                    text: status,
                    color: "#6c757d",
                    bgColor: "rgba(108, 117, 125, 0.1)",
                    icon: "las la-question-circle",
                };
        }
    };

    const config = getStatusConfig();

    return (
        <div
            className="ticket-status"
            style={{
                color: config.color,
                background: config.bgColor,
                border: `1px solid ${config.color}`,
                padding: "6px 14px",
                borderRadius: "16px",
                fontSize: "12px",
                fontWeight: "600",
                textTransform: "uppercase",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
            }}
        >
            <i className={config.icon} />
            <span>{config.text}</span>
        </div>
    );
};

export default TicketStatus;
